/**
 * Verifica se um elemento HTML possui rolagem.
 *
 * @param target Elemento HTML a ser verificado.
 *
 * @category Scroll
 */
export const isElementScrollable = (target) => target.scrollHeight > target.offsetHeight || target.scrollWidth > target.offsetWidth;
/**
 * Realiza scroll horizontal centralizando o elemento dentro de um container com rolagem.
 *
 * @param target Elemento HTML a ser centralizado.
 * @param container Elemento HTML com rolagem onde o elemento a ser centralizado está contido.
 * @param scrollBehavior Comportamento do scroll a ser executado.
 *
 * @category Scroll
 */
export const scrollIntoViewX = (target, container, scrollBehavior = 'smooth') => {
    const scroll = target.offsetLeft - (container.clientWidth - target.offsetWidth) / 2;
    container.scrollTo({
        left: scroll,
        behavior: scrollBehavior,
    });
};
/**
 * Procura pelo primeiro elemento HTML pai com rolagem.
 *
 * @param target Elemento HTML onde começará a busca.
 *
 * @category Scroll
 */
export const getScrollingParent = (target) => {
    if (!target) {
        return document.scrollingElement;
    }
    if (isElementScrollable(target)) {
        return target;
    }
    return getScrollingParent(target.parentNode);
};
//# sourceMappingURL=scroll.js.map